/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import { BaseButton, useTableColumn } from 'xrk-components';
import { date, fen2yuan, maskAllMethod } from '@/utils/formatter';
import { PAY_TYPE } from '@/common/constants/order';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank/index';
import { downLoadReceipt } from '@/common/hooks/order/order-download';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '@/views/asp-order/src/constants';

/** 订单编号 */
export const orderNoCol = useTableColumn({
  label: '订单编号',
  prop: 'orderNo',
  width: 220
});

/** 关联项目订单编号 */
export const refProjectOrderNoCol = useTableColumn({
  label: '关联项目订单编号',
  prop: 'refProjectOrderNo',
  width: 220
});

/** 个体工商户名称 */
export const individualNameCol = useTableColumn({
  label: '个体工商户名称',
  prop: 'individualName',
  width: 300
});

/** 经营者 */
export const fullNameCol = useTableColumn({
  label: '经营者',
  prop: 'operator',
  formatter: ({ cellValue }) => maskAllMethod({ type: 'name', val: cellValue })
});

/** 手机号 */
export const phoneCol = useTableColumn({
  label: '手机号',
  prop: 'phone',
  formatter: ({ cellValue }) => maskAllMethod({ type: 'phone', val: cellValue })
});

/** 终端结算金额（元） */
export const projectPayPriceCol = useTableColumn({
  label: '终端结算金额（元）',
  prop: 'terminalSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 项目名称 */
export const projectNameCol = useTableColumn({
  label: '项目名称',
  prop: 'projectName',
  width: 300
});

/** 项目编码 */
export const projectNoCol = useTableColumn({
  label: '项目编码',
  prop: 'projectCode',
  width: 150
});

/** 工业名称 */
export const entpNameCol = useTableColumn({
  label: '工业名称',
  prop: 'industryName',
  width: 300
});

/** 服务商名称 */
export const aspNameCol = useTableColumn({
  label: '服务商名称',
  prop: 'aspName',
  width: 300
});

/** 订单支付时间 */
export const orderPayTimeCol = useTableColumn({
  label: '订单支付时间',
  prop: 'orderPayTime',
  width: 180,
  formatter: ({ cellValue }) => date(cellValue)
});

/** 支付方式 */
export const payTypeCol = useTableColumn({
  label: '支付方式',
  prop: 'payType',
  formatter({ cellValue }) {
    return PAY_TYPE[cellValue]?.label;
  }
});

/** 支付通道 */
export const payPassagewayCol = useTableColumn({
  label: '支付通道',
  prop: 'payPassagewayCode',
  formatter({ cellValue }) {
    return PAY_PASSAGEWAY_MAPPING?.[cellValue]?.label || '-';
  }
});

/** 个体税金及服务费率（%） */
export const proxyScaleCol = useTableColumn({
  label: '个体税金及服务费率（%）',
  prop: 'proxyScale',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 个体税金及服务费 */
export const proxyScalePriceCol = useTableColumn({
  label: '个体税金及服务费金额（元）',
  prop: 'proxyScalePrice',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 支付状态 */
export const payStatusCol = useTableColumn({
  label: '支付状态',
  prop: 'payStatus',
  formatter({ cellValue }) {
    return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
  }
});

/** 所属园区 */
export const businessParkNameCol = useTableColumn({
  label: '所属园区',
  prop: 'belongingPark'
});

/** 下载回单 */
export const downloadReceiptCol = () => {
  return useTableColumn({
    label: '操作',
    fixed: 'right',
    render({ row }) {
      return (
        <>
          <BaseButton
            type="text"
            disabled={
              +row.payStatus !== 2 || !row.receiptUrl || row.receiptUrl === '-'
            }
            click={async () => {
              //下载回单
              downLoadReceipt(row.receiptUrl);
            }}
          >
            下载回单
          </BaseButton>
        </>
      );
    }
  });
};

/**
 * 个体税金及服务费订单
 */

export const getServiceCol = () => {
  return [
    orderNoCol,
    refProjectOrderNoCol,
    individualNameCol,
    fullNameCol,
    businessParkNameCol,
    phoneCol,
    entpNameCol,
    aspNameCol,
    projectNameCol,
    projectNoCol,
    orderPayTimeCol,
    projectPayPriceCol,
    proxyScaleCol,
    proxyScalePriceCol,
    payStatusCol,
    payPassagewayCol,
    payTypeCol,
    downloadReceiptCol()
  ];
};
